module.exports = __webpack_public_path__ + "img/logo-st.ac30d72b.png";